import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
  position: relative;

  /* garante: o letreiro (led-layer) fica atrás,
     e o restante do conteúdo desta seção fica na frente */
  & > .led-layer {
    z-index: 0;
  }
  & > *:not(.led-layer) {
    position: relative;
    z-index: 1;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 16px;
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px; 
  width: 100%;
  padding: 40px 16px;
  margin: 0 auto;
  margin-top: -1px;
  padding-bottom: 33px;

  @media (min-width: 1200px) {
    padding: 0 120px 40px;
  }
`;

export const Card = styled.div`
  padding: 24px;
  background-color: var(--white);

  display: flex;
  /* max-width: 1200px; */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 44px;
  align-self: stretch;
  border-radius: 24px;

  @media (min-width: 1200px) {
    flex-direction: row;
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  text-align: left;

  h2{
    color: var(--orange-500);
    font-size: 24px;
    font-style: normal;
    font-weight: 550;
    line-height: 32px;
    letter-spacing: 1px;
  }

  p{
    color: var(--orange-900);
    font-size: 14px;
    font-style: normal;
    font-weight: 325;
    line-height: 20px;
    letter-spacing: 1px;
  }

  img{
    width: 147px;
  }

  @media (min-width: 768px) {
    h2{
      font-size: 48px;
      line-height: 56px; 
      letter-spacing: 2px;
    }

    p{
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const BottomCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  margin-top: 48px; 

  h3{
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 550;
    line-height: 40px; 
    letter-spacing: 1px;
    max-width: 800px;
  }

  p{
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 325;
    line-height: 20px; 
    letter-spacing: 1px;
  }

  @media (min-width: 768px) {
    h3{
      font-size: 56px;
      line-height: 64px;
      letter-spacing: 2px;
    }

    p{
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

export const ActionBtn = styled.button`
  background-color: var(--orange-50);
  border: 1px solid var(--orange-50);
  color: var(--orange-500);
`;
